module.exports = __webpack_public_path__ + "static/media/dollar-sign.056c5ac0.svg";